import PropTypes from 'prop-types'

import {styled} from '@mui/material'

import CloseIcon from '../../../core/svg_icons/icons/CloseIcon'
import StyledBaseBox from '../../boxes/StyledBaseBox'
import StyledBaseModal from '../StyledBaseModal'
import breakpoints from '../../../../dashboard/styles/abstracts/breakpoints.module.scss'

const StyledMediumModalContent = styled(StyledBaseBox)(
  () => `
    margin: 50px auto;
    max-width: 600px;
    padding: 32px;
    position: relative;
    @media (min-width: ${breakpoints.tabletMd}) {
      padding: 40px;
    }
  `
)

const StyledMediumModal = ({children, onClose, ...otherProps}) => (
  <StyledBaseModal {...otherProps} dataTestId='medium-modal' onClose={onClose}>
    <StyledMediumModalContent className='medium-modal-content'>
      <CloseIcon
        data-testid='close-icon'
        height='15'
        onClick={onClose}
        style={{alignSelf: 'flex-end', cursor: 'pointer', zIndex: '10'}}
        width='15'
      />
      {children}
    </StyledMediumModalContent>
  </StyledBaseModal>
)

StyledMediumModal.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired
}

export default StyledMediumModal
